import EmptyState from '@features/regional-overview/digital-traps/components/empty-state';
import { DAILY_COUNTS_TAB } from '@features/regional-overview/digital-traps/domain/tests-id.constants';
import { EmptyStateWrapper } from '../../trap-management-tabs.style';
import { DailyCountsObservedCardList } from './daily-counts-observed-card-list';
import { useObservedCountsData } from './observed-counts-data.hook';

export const ObservedCountsTab = () => {
  const { networks, anchorDate } = useObservedCountsData();

  if (!Array.isArray(networks) || networks.length === 0) {
    return (
      <EmptyStateWrapper>
        <EmptyState context='search' />
      </EmptyStateWrapper>
    );
  }

  return <DailyCountsObservedCardList dataTestId={DAILY_COUNTS_TAB} groups={networks} anchorDate={anchorDate} />;
};
